export const OpenIcon = () => {
	return (
		<svg
			width="20"
			height="20"
			viewBox="0 0 16 16"
			fill="currentColor"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M7.80273 10.8775C7.80273 6.87752 7.80274 2.37752 7.80274 0.47599M7.80274 0.47599L5.18738 2.5798M7.80274 0.47599L10.4697 2.5798"
				stroke="currentColor"
				strokeWidth="0.561364"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path d="M13.9746 9C14.7464 9 15.372 9.62566 15.3721 10.3975V13.9756L15.3652 14.1182C15.2984 14.7757 14.7757 15.2983 14.1182 15.3652L13.9746 15.373H1.39746L1.25488 15.3652C0.597079 15.2985 0.0736612 14.7759 0.00683594 14.1182L0 13.9756V10.4004C0 9.67552 0.55088 9.07853 1.25684 9.00684L1.40039 9H2.19922V9.55957H1.40039C0.936471 9.55957 0.55957 9.93647 0.55957 10.4004V13.9756C0.559787 14.4379 0.935074 14.8125 1.39746 14.8125H13.9746C14.437 14.8125 14.8123 14.4379 14.8125 13.9756V10.3975C14.8125 9.93494 14.4371 9.55957 13.9746 9.55957H13.1992V9H13.9746Z" />
		</svg>
	);
};
